import React from 'react';
import { EditHistoryHook } from '../../types';
import { UndoIcon, RedoIcon } from '../../icons';
import Button from '../ui/Button';

interface UndoRedoToolbarProps {
  editHistoryHook: EditHistoryHook;
  className?: string;
}

const UndoRedoToolbar: React.FC<UndoRedoToolbarProps> = ({
  editHistoryHook,
  className = '',
}) => {
  if (!editHistoryHook) {
    return null;
  }

  const { canUndo, canRedo, undo, redo, isLoading, editHistory } =
    editHistoryHook;

  return (
    <div
      className={`flex items-center gap-2 ${className}`}
      data-tutorial="undo-redo-toolbar"
    >
      {/* Undo Button */}
      <Button
        variant="secondary"
        size="sm"
        onClick={undo}
        disabled={!canUndo || isLoading}
        title={`Undo${canUndo ? ' (Ctrl+Z)' : ''}`}
        className="flex items-center gap-1"
      >
        <UndoIcon size={16} />
        Undo
      </Button>

      {/* Redo Button */}
      <Button
        variant="secondary"
        size="sm"
        onClick={redo}
        disabled={!canRedo || isLoading}
        title={`Redo${canRedo ? ' (Ctrl+Shift+Z)' : ''}`}
        className="flex items-center gap-1"
      >
        <RedoIcon size={16} />
        Redo
      </Button>

      {/* Operation count indicator */}
      {editHistory && editHistory.operations.length > 0 && (
        <span className="text-sm text-gray-500 dark:text-gray-400 ml-2">
          {editHistory.currentIndex + 1} / {editHistory.operations.length}
        </span>
      )}
    </div>
  );
};

export default UndoRedoToolbar;
